import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ede041a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-tag-wrap" }
const _hoisted_2 = ["src"]


import successIcon from '@/assets/icon-rights-success.svg'
import warningIcon from '@/assets/icon-rights-warn.svg'

export default /*#__PURE__*/_defineComponent({
  __name: 'right-reminder',
  props: {
    info: null
  },
  setup(__props: any) {

const prop = __props as {
  info: Array<{
    text: string
    flag: boolean
  }>
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prop.info, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        style: _normalizeStyle({ ...item, backgroundColor: !item.flag ? '#fff8ef' : '' })
      }, [
        _createElementVNode("img", {
          width: "16",
          height: "16",
          src: item.flag ? _unref(successIcon) : _unref(warningIcon)
        }, null, 8, _hoisted_2),
        _createElementVNode("div", null, _toDisplayString(item.text), 1)
      ], 4))
    }), 128))
  ]))
}
}

})